import { default_dashboard } from '@core/breadcrumbs';

const module = default_dashboard
  .extend('autocaller_v2')
  .add('autocaller_v2.breadcrumb.title', { name: 'autocaller_v2.campaign.index' });

const campaigns_breadcrumbs = module
  .extend('autocaller_v2.campaign.index')
  .add('autocaller_v2.breadcrumb.campaign.index', { name: 'autocaller_v2.campaign.index' });

const create_campaigns_breadcrumbs = campaigns_breadcrumbs
  .extend('autocaller_v2.campaign.new')
  .add('autocaller_v2.campaign.create.title', { name: 'autocaller_v2.campaign.new' });

const edit_campaigns_breadcrumbs = campaigns_breadcrumbs
  .extend('autocaller_v2.campaign.edit')
  .add('autocaller_v2.campaign.edit.title', { name: 'autocaller_v2.campaign.edit' });

const task_campaigns_breadcrumbs = module
  .extend('autocaller_v2.task.index')
  .add('autocaller_v2.task.index.title', { name: 'autocaller_v2.task.index.title' });

const settings_breadcrumbs = module
  .extend('autocaller_v2.settings.index')
  .add('autocaller_v2.breadcrumb.settings.index', { name: 'autocaller_v2.settings.index' });

const webhook_breadcrumbs = module
  .extend('autocaller_v2.webhooks.index')
  .add('autocaller_v2.breadcrumb.webhook.index', { name: 'autocaller_v2.webhooks.index' });

const operators_breadcrumbs = module
  .extend('autocaller_v2.operators.index')
  .add('autocaller_v2.breadcrumb.operators.index', { name: 'autocaller_v2.operators.index' });

const monitoring_breadcrumbs = module
  .extend('autocaller_v2.monitoring.index')
  .add('autocaller_v2.monitoring.index.title', { name: 'autocaller_v2.monitoring.index.title' });

const stats_breadcrumbs = module
  .extend('autocaller_v2.stats.type')
  .add('shared.breadcrumb.stats.title', { name: `autocaller_v2.stats.index` });

const monitoring_general_breadcrumbs = module
  .extend('autocaller_v2.monitoring_general.index')
  .add('autocaller_v2.monitoring_general.index.title', {
    name: `autocaller_v2.monitoring_general.index.title`
  });

const autocaller_v2_breadcrumbs = [
  campaigns_breadcrumbs,
  create_campaigns_breadcrumbs,
  edit_campaigns_breadcrumbs,
  webhook_breadcrumbs,
  operators_breadcrumbs,
  stats_breadcrumbs,
  task_campaigns_breadcrumbs,
  monitoring_breadcrumbs,
  monitoring_general_breadcrumbs,
  settings_breadcrumbs
];

export { autocaller_v2_breadcrumbs };
